// The UNDERLINE PROGRESS visual of a home widget (HOME_WIDGETS_SPEC.md §2):
// a 4 px capsule, the widget hue on a `layer` track. The one visual an S
// widget keeps.
//
//   HomeWidgetProgress: { ratio: (el, s) => el.call('pgCoverageRatio', s.root) }
//
// `ratio` is 0..1 (clamped). Null/undefined = not read yet: the empty track
// pulses as its own skeleton, same box, zero shift.
export const HomeWidgetProgress = {
  class: 'home-widget-visual',
  gridArea: 'visual',
  alignSelf: 'center',
  width: '100%',
  height: 'X',
  round: 'radiusPill',
  theme: 'layer',
  overflow: 'hidden',
  role: 'progressbar',
  'aria-valuemin': '0',
  'aria-valuemax': '100',
  'aria-valuenow': (el) =>
    el.ratio == null
      ? null
      : String(Math.round(Math.min(1, Math.max(0, Number(el.ratio) || 0)) * 100)),
  animation: (el) => (el.ratio == null ? 'pulse 1.5s ease-in-out infinite' : 'none'),
  ratio: null,

  Fill: {
    height: '100%',
    round: 'radiusPill',
    background: '--home-widget-accent',
    transition: 'width C defaultBezier',
    width: (el) => {
      const r = el.parent.ratio
      const v = r == null ? 0 : Math.min(1, Math.max(0, Number(r) || 0))
      return Math.round(v * 1000) / 10 + '%'
    }
  }
}
